import * as React from 'react';
import { Form, Input, Button, Divider, message } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import ResetPasswordDTO from 'src/models/account/ResetPasswordDTO';
import UserApiController from 'src/api/UserApiController';
import { NameOf } from 'src/utils/NameOf';
import FieldDecorator from 'src/components/common/form/FieldDecorator';

interface USResetPasswordFormProps extends FormComponentProps, LocalizeContextProps {
    passwordData: Partial<ResetPasswordDTO>;

    isSubmitting: boolean;

    onSubmit: (values: ResetPasswordDTO) => void;
    onCancel: () => void;
}

class USResetPasswordForm extends React.Component<USResetPasswordFormProps> {
    constructor(props: USResetPasswordFormProps) {
        super(props);
        bindAllOfThis(this, USResetPasswordForm.prototype);
    }

    private compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== this.props.form.getFieldValue('newPassword')) {
            callback(this.props.translate('account.resetPassword.saveTooltip').toString());
        } else {
            callback();
        }
    }

    private validateToNextPassword = (rule, value, callback) => {
        if (this.props.form.getFieldValue('confirmPassword')) {
            this.props.form.validateFields(['confirmPassword'], { force: true }, (errors, values) => console.log('Revalidating'));
        }
        callback();
    }

    private handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        this.props.form.validateFields((errors, values: ResetPasswordDTO) => {
            let newValues = { ...this.props.passwordData, ...values } as ResetPasswordDTO;
            if (!errors) {
                this.props.onSubmit && this.props.onSubmit(newValues);
            }
        });
    }

    private handleCancel() {
        this.props.onCancel && this.props.onCancel();
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 5 },
        };

        return (
            <Form className="password-reset" onSubmit={this.handleSubmit}>
                <FieldDecorator
                    form={this.props.form}
                    label={<Translate id="account.resetPassword.formItem1" />}
                    name={NameOf<ResetPasswordDTO>("newPassword")}
                    rules={[
                        { required: true, message: <Translate id="admin.common.requiredRule" /> },
                        { min: 8, message: <React.Fragment><Translate id="admin.common.minLengthRule" /> 8</React.Fragment> },
                        { validator: this.validateToNextPassword }
                    ]}
                    {...formItemLayout}
                >
                    <Input autoComplete="off" type="password" />
                </FieldDecorator>

                <FieldDecorator
                    form={this.props.form}
                    label={<Translate id="account.resetPassword.formItem2" />}
                    name={NameOf<ResetPasswordDTO>("confirmPassword")}
                    rules={[
                        { required: true, message: <Translate id="admin.common.requiredRule" /> },
                        { validator: this.compareToFirstPassword }
                    ]}
                    {...formItemLayout}
                >
                    <Input autoComplete="off" type="password" />
                </FieldDecorator>

                <Form.Item>
                    <Button type="primary" loading={this.props.isSubmitting} htmlType="submit">
                        <Translate id="admin.common.saveButton" />
                    </Button>
                    <Divider type="vertical" />
                    <Button onClick={this.handleCancel}>
                        <Translate id="common.back" />
                    </Button>
                </Form.Item>
            </Form>
        );
    }
}

export default withLocalize(Form.create()(USResetPasswordForm));



// WEBPACK FOOTER //
// ./src/pages/admin/universalSearch/USResetPasswordForm.tsx